import { useEffect, useState } from 'react';
import './data-freshness.css';

export const DATA_STALE_MS = 5 * 60_000;
export function dataObservedAt(value: string | number | null | undefined): number | null {
  const time = typeof value === 'number' ? value : value ? Date.parse(value) : NaN;
  return Number.isFinite(time) ? time : null;
}
const dateFormat = new Intl.DateTimeFormat('pt-BR', { timeZone: 'America/Sao_Paulo',
  day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' });

/** A hora vem da fotografia recebida, nunca do render ou de uma tentativa que falhou. */
export function DataFreshness({ at, failed = false, loading = false, label = 'Atualizado' }: {
  at: string | number | null | undefined; failed?: boolean; loading?: boolean; label?: string;
}) {
  const [now, setNow] = useState(Date.now);
  const [offline, setOffline] = useState(() => navigator.onLine === false);
  useEffect(() => {
    const tick = () => { setNow(Date.now()); setOffline(navigator.onLine === false); };
    const timer = setInterval(tick, 15_000);
    document.addEventListener('visibilitychange', tick);
    window.addEventListener('focus', tick); window.addEventListener('online', tick); window.addEventListener('offline', tick);
    return () => {
      clearInterval(timer); document.removeEventListener('visibilitychange', tick);
      window.removeEventListener('focus', tick); window.removeEventListener('online', tick); window.removeEventListener('offline', tick);
    };
  }, []);
  const time = dataObservedAt(at);
  const age = time === null ? null : Math.max(0, now - time);
  const stale = age !== null && age >= DATA_STALE_MS;
  const warning = failed || offline || stale;
  const relative = age === null ? '' : age < 60_000 ? 'agora' : `há ${Math.floor(age / 60_000)} min`;
  return <div className={`data-freshness${warning ? ' is-stale' : ''}`} role="status" aria-label="Atualidade dos dados" data-testid="data-freshness">
    <span>{time === null ? loading && !failed && !offline ? 'Consultando as fontes…' : 'Sem leitura confirmada' : <>{label} <time dateTime={new Date(time).toISOString()}>{dateFormat.format(time).replace(', ', ' ')} BRT</time> <span className="data-age">({relative})</span></>}</span>
    {warning ? <strong>{offline ? 'Sem conexão — os dados podem estar obsoletos.' : failed ? time === null ? 'Não foi possível confirmar os dados.' : 'Falha na atualização — última leitura preservada.' : 'Dados obsoletos — aguardando nova leitura.'}</strong> : loading && time !== null ? <span>Atualizando…</span> : null}
  </div>;
}
